import { render, staticRenderFns } from "./AdminSessionNew.vue?vue&type=template&id=6772aa20&scoped=true&"
import script from "./AdminSessionNew.vue?vue&type=script&lang=js&"
export * from "./AdminSessionNew.vue?vue&type=script&lang=js&"
import style0 from "./AdminSessionNew.vue?vue&type=style&index=0&id=6772aa20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6772aa20",
  null
  
)

export default component.exports